import { useRef } from "react";

// Backdrop-dismiss handlers for a modal overlay. A naive onClick on the overlay
// also fires when the user presses inside the modal (e.g. drag-selecting text
// in an input) and releases over the backdrop — that gesture shouldn't close
// the modal. So dismiss only when a gesture both starts AND ends on the overlay
// element itself. Spread the result onto the .modal-overlay element; pass
// `locked` (e.g. while submitting) to suppress dismissal.
export function useOverlayDismiss(onDismiss: () => void, locked = false) {
  const startedOnOverlay = useRef(false);
  return {
    onMouseDown: (event: React.MouseEvent) => {
      startedOnOverlay.current = event.target === event.currentTarget;
    },
    onMouseUp: (event: React.MouseEvent) => {
      const started = startedOnOverlay.current;
      startedOnOverlay.current = false;
      if (started && event.target === event.currentTarget && !locked) {
        onDismiss();
      }
    }
  };
}
